var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 38,
    viewBox: "0 0 38 38",
    width: 38,
    className: "injected-svg",
    "data-src": "/static/media/time.0c7b129c.svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 0c-3.7578 0-7.4313 1.11433-10.55583 3.20208-3.12453 2.08774-5.55981 5.05514-6.99787 8.52692-1.43806755 3.4718-1.814331 7.2921-1.081212 10.9777.733122 3.6856 2.542692 7.0711 5.199892 9.7283s6.04272 4.4668 9.72832 5.1999 7.5059.3569 10.9777-1.0812 6.4392-3.8733 8.5269-6.9979c2.0878-3.1245 3.2021-6.798 3.2021-10.5558-.0057-5.0374-2.0093-9.86677-5.5713-13.42872-3.5619-3.56195-8.3913-5.56556546-13.4287-5.57128zm6.1063 25.1069c-.324.3239-.7633.5058-1.2213.5058-.4581 0-.8974-.1819-1.2213-.5058l-4.8844-4.8852c-.3206-.3228-.5019-.7585-.5048-1.2134l-.0018-.0083v-6.9091c0-.4581.182-.8974.5059-1.2214.324-.3239.7633-.5059 1.2214-.5059s.8974.182 1.2214.5059c.3239.324.5059.7633.5059 1.2214v6.194l4.379 4.3797c.3238.3239.5057.7631.5057 1.2212 0 .458-.1819.8972-.5057 1.2211z",
    fill: "#f3a952"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.10ce8ee77005a22a91aa6931abaf7920.svg";
export { ForwardRef as ReactComponent };